import React from "react";
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import { Button, IconButton, Tooltip } from '@mui/material';

const tableHeader = (Translation: any, AddTask: any, refreshData: any, enableCreate: any) => [
    [
        { type: 'header', label: Translation('form.pulseleads.engagement.topic.list'), sm: true },
        {
            type: 'custom',
            sm: false,
            render: () =>
                <Tooltip title="Refresh">
                    <IconButton style={{ marginRight: 15 }} onClick={refreshData}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
        },
        {
            type: 'custom',
            sm: false,
            render: () =>
               <Button variant="contained" color="secondary" onClick={AddTask} >
                   <AddIcon />{Translation('app.button.add')}
                </Button>
        },
    ],
];


export default tableHeader;